<template>
  <form @submit.prevent="submitSearch">
    <div class="search-input">
      <input type="text" placeholder="Type and hit enter to search." v-model="searchInput" />
      <a href="javascript:;" v-show="searchInput !== ''" @click="clearSearch">
        <i class="far fa-times-circle fa-lg fa-fw"></i>
      </a>
    </div>
  </form>
</template>

<script>
import ApiRoutingReservation from '@/modules/api/routing/reservations'
export default {
  name: 'table-search',
  computed: {
    searchInput: {
      get () { return this.$store.state.routing.reservationSearch },
      set (value) { this.$store.commit('routing/setReservationSearch', value) }
    }
  },
  methods: {
    submitSearch () {
      let self = this
      self.$store.commit('routing/setReservationsCurrentPage', 1)
      self.$store.commit('routing/setPackageCurrentPage', 1)
      ApiRoutingReservation.getReservations(self, r => {}, false)
      ApiRoutingReservation.getPackages(self, r => {}, false)
    },
    clearSearch () {
      let self = this
      self.$store.commit('routing/resetReservationSearch')
      ApiRoutingReservation.getReservations(self, r => {}, false)
      ApiRoutingReservation.getPackages(self, r => {}, false)
    }
  }
}
</script>

<style lang="scss" scoped>
form{
  position: relative;
  width: 40%;
  display: inline-block;
}
input {
  margin: 0;
  border-radius: 0;
  padding: 0 15px;
  height: 50px;
  line-height: 50px;
  border-top: 0;
  border-bottom: 1px solid rgba(0,0,0,0.0);
  border-color: rgba(0,0,0,0.2);
}

.search-input{
  position: relative;

  & a {
    position: absolute;
    top: 0;
    right: 0;
    height: 50px;
    line-height: 50px;
    color: #777;
    width: 50px;
    text-align: center;

    & i { line-height: inherit; }
  }
}

@media only screen and (max-width: 430px) {
  form {
    width: 50%;
  }

  input {
    padding-left: 60px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Routing/TableSearch.vue